import { viewTotalDiscountAmount } from "./formatData";

export type CouponDiscountTotals = {
  discountCodeAmount: number;
  taxAfterDiscount: number;
  consumptionTaxAfterDiscount: number;
};

export const getCouponDiscountTotals = (
  products: any[],
  coupons: Coupon[],
  grossAmount: number,
  taxAmountTotal: number,
  consumptionTaxAmountTotal: number,
  defaultLanguage: string
): CouponDiscountTotals => {
  if (!coupons || coupons.length === 0) {
    return {
      discountCodeAmount: 0,
      taxAfterDiscount: taxAmountTotal,
      consumptionTaxAfterDiscount: consumptionTaxAmountTotal,
    };
  }

  const dataDiscount = viewTotalDiscountAmount(
    products,
    coupons,
    grossAmount,
    "",
    "COP",
    defaultLanguage
  );

  return {
    discountCodeAmount: parseFloat(
      dataDiscount.amount ? dataDiscount.amount.toString() : "0"
    ),
    taxAfterDiscount: taxAmountTotal - dataDiscount.amountTax,
    consumptionTaxAfterDiscount:
      consumptionTaxAmountTotal - dataDiscount.amountConsumptionTax,
  };
};
